import React, { Component } from 'react';
import { COLORS } from '../../styles/colors';
/**
 * Placeholder
 */
export class SandboxContent extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    hover: false,
    dragMoved: false
  }

  changeDragMoved() {
    const foo = document.getElementById(this.props.dragId);
    if (foo) {
      let compStyles = window.getComputedStyle(foo);

      if (compStyles.getPropertyValue('transform') !== 'none') {
        this.setState({
          ...this.state,
          dragMoved: true
        })
      }else{
        this.setState({
          ...this.state,
          dragMoved: false
        })
      }

    }
  }
  render() {

    const {hover, dragMoved } = this.state;
    let text = "DROP EXERCISE HERE";
    if (this.props.draggingItem) {
      text = this.props.draggingItem.type === 'circuit'
        ? "DROP CIRCUIT ROUND HERE"
        : "DROP EXERCISE HERE";
    }
    return (
      <div style={{position:'relative'}}
      onMouseMove={() => this.changeDragMoved()}
      onMouseOver={() => this.setState({hover: true})}
      onMouseLeave={() => this.setState({hover: false})}>
        { this.props.Draggable }
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 1,
          fontSize: 18,
          color: COLORS.grey,
          width: '100%',
          backgroundColor: hover && this.props.isHoveringOver && dragMoved ? COLORS.blue : 'transparent',
          height: 38
        }}>
          { hover && this.props.isHoveringOver && dragMoved ? text : ''}
        </div>
      </div>

    );
  }
}

export default SandboxContent;



// WEBPACK FOOTER //
// ./src/components/workouts/SandboxContent.js